function planKey(plan) {
  return ((plan && (plan.pricing_id || plan.plan_code)) || '').toUpperCase();
}

function findMoStandardPlan(pricePlans) {
  const active = (pricePlans || []).filter(function (p) {
    return p.status === 'ACTIVE';
  });
  return (
    active.find(function (p) {
      return (
        p.loan_term === '12M' ||
        p.loan_term === 'MOSTANDARD' ||
        /MOSTANDARD(25|35)/.test(planKey(p)) ||
        /^MOSTANDARD/i.test(p.plan_code || '')
      );
    }) || null
  );
}

function findMoSaverPlan(pricePlans) {
  const active = (pricePlans || []).filter(function (p) {
    return p.status === 'ACTIVE';
  });
  return (
    active.find(function (p) {
      return (
        p.loan_term === '3M' ||
        p.loan_term === 'MOSAVER' ||
        planKey(p).includes('MOSAVER')
      );
    }) || null
  );
}

function findMoLitePlan(pricePlans) {
  const active = (pricePlans || []).filter(function (p) {
    return p.status === 'ACTIVE';
  });
  const mostandard = findMoStandardPlan(pricePlans);
  return (
    active.find(function (p) {
      return p.loan_term === 'STDHIGH' && p !== mostandard;
    }) || null
  );
}

function getMoStandardDisplayPricing(plan) {
  if (!plan) return { weekly: null, deposit: null };
  return {
    weekly: plan.fin_12_month_weekly,
    deposit: plan.fin_deposit,
  };
}

function getMoSaverDisplayPricing(plan) {
  if (!plan) return { weekly: null, deposit: null };
  return {
    weekly: plan.fin_3_month_weekly,
    deposit: plan.fin_deposit,
  };
}

function parseTermMonths(term) {
  const match = String(term || '').match(/(\d+)/);
  return match ? Number(match[1]) : 0;
}

function isMoSaverPlan(plan) {
  if (!plan) return false;
  const term = String(plan.loan_term || '').toUpperCase();
  const code = String(plan.plan_code || '').toUpperCase();
  return term === 'MOSAVER' || term === '3M' || code.includes('MOSAVER');
}

function getSortedEarlyPayoffs(plan) {
  return ((plan && plan.early_payoffs) || [])
    .slice()
    .sort(function (a, b) {
      return Number(a.within_months) - Number(b.within_months);
    });
}

function findEarlyPayoffForTerm(plan, term) {
  const months = parseTermMonths(term);
  const earlyPayoffs = getSortedEarlyPayoffs(plan);
  if (!months || earlyPayoffs.length === 0) return null;

  return (
    earlyPayoffs.find(function (ep) {
      return Number(ep.within_months) === months;
    }) || null
  );
}

  function isEarlyPayoffWindowTerm(plan, term) {
  const months = parseTermMonths(term);
  if (!months) return false;
  if (isMoSaverPlan(plan)) {
    // MoSaver full term is 6 months in UI; 1/2/3 are early-payoff windows
    return months === 1 || months === 2 || months === 3;
  }
  // MoStandard / MoLite: 3/6/9 are early-payoff windows; 12 is full term
  return months === 3 || months === 6 || months === 9;
}

function isFullTerm(plan, term) {
  const months = parseTermMonths(term);
  if (!months) return false;
  if (isMoSaverPlan(plan)) {
    return months === 6;
  }
  return months === 12;
}

/** MoSaver: 1/2/3 EP + 6 full. MoStandard: 3/6/9 EP + 12 full. */
function isValidPlanTermCombo(planOrLabel, term) {
  const months = parseTermMonths(term);
  if (!months) return false;
  const label = String(
    (planOrLabel && (planOrLabel.plan_code || planOrLabel.loan_term || planOrLabel)) || '',
  ).toUpperCase();
  const isSaver =
    (typeof planOrLabel === 'object' && isMoSaverPlan(planOrLabel)) ||
    label.includes('SAVER') ||
    label === 'MOSAVER';
  if (isSaver) {
    return months === 1 || months === 2 || months === 3 || months === 6;
  }
  // MoStandard / MoLite / unknown standard-like
  return months === 3 || months === 6 || months === 9 || months === 12;
}

function formatEarlyPayoffDuration(earlyPayoff) {
  if (!earlyPayoff) return '';
  var months = Number(earlyPayoff.within_months);
  var unit = months === 1 ? 'Month' : 'Months';
  return months + ' ' + unit + ' - ' + earlyPayoff.discount_percent + '% Off';
}

function formatFullTermDuration(term) {
  var months = parseTermMonths(term);
  if (!months) return String(term || '');
  return months === 1 ? '1 Month' : months + ' Months';
}

function calculatePricingFromEarlyPayoff(plan, term, useHigh) {
  if (!plan) return { deposit: 0, weeklyPrice: 0, earlyPayoff: null };

  // MoSaver has no 9/12; do not invent full-term figures for invalid combos
  if (!isValidPlanTermCombo(plan, term)) {
    return { deposit: 0, weeklyPrice: 0, earlyPayoff: null };
  }

  var earlyPayoff = findEarlyPayoffForTerm(plan, term);
  if (earlyPayoff) {
    var deposit = useHigh
      ? earlyPayoff.deposit_amount_high || earlyPayoff.deposit_amount || 0
      : earlyPayoff.deposit_amount || 0;
    var weeklyPrice = useHigh
      ? earlyPayoff.weekly_instalment_amount_high || 0
      : earlyPayoff.weekly_instalment_amount || 0;
    return { deposit: deposit, weeklyPrice: weeklyPrice, earlyPayoff: earlyPayoff };
  }

  // Early-payoff windows must not fall back to full-term pricing
  if (isEarlyPayoffWindowTerm(plan, term)) {
    return { deposit: 0, weeklyPrice: 0, earlyPayoff: null };
  }

  if (!isFullTerm(plan, term)) {
    return { deposit: 0, weeklyPrice: 0, earlyPayoff: null };
  }

  var depositFull = plan.fin_deposit || 0;
  var weeklyFull = 0;
  if (isMoSaverPlan(plan)) {
    weeklyFull = plan.fin_3_month_weekly || 0;
  } else {
    weeklyFull = plan.fin_12_month_weekly || 0;
  }

  return {
    deposit: depositFull,
    weeklyPrice: weeklyFull,
    earlyPayoff: null,
  };
}

function formatKes(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n.toLocaleString('en-KE', {
    style: 'currency',
    currency: 'KES',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

